import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zEmailNotification = zDocument.extend({
    type: z.literal('emailNotification'),
    user: z.string(),
    notifications: z.array(z.string())
});
expectType({});
expectType({});
export const EmptyEmailNotification = {
    type: 'emailNotification',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    user: '',
    notifications: []
};
